// import jwt from 'jsonwebtoken';
import Cookies from "js-cookie";
import { postFetch } from "../../utils/fetch";
import { encryptAndStore, removeFromStorage } from "../../utils/user_data";

async function login(formData) {
  const user = formData.get("username");
  const password = formData.get("password");

  if (user === "") {
    return {
      status: "validate",
      message: "نام کاربری الزامی است!",
    };
  }
  if (password === "") {
    return {
      status: "validate",
      message: "رمز عبور الزامی است!",
    };
  }

  const response = await postFetch("/auth/login", formData);
  if (response.status === "success") {
    encryptAndStore('bargo',response.account.username);
    Cookies.set("login_token", response.Token, {
      expires: 7,
      path: "/",
      secure: false,
      sameSite: "lax",
    });

    return {
      status: "success",
      message: "ورود موفقیت آمیز!",
    };
  } else {
    return {
      status: "error",
      message:
        response.message === 401
          ? "نام کاربری یا رمز عبور اشتباه است!"
          : response.message === 403
          ? "سطح کاربر شما دسترسی به پنل مدیریت را ندارد"
          : "خطا در اتصال به سرور!",
    };
  }
}

async function logout() {
  const token = Cookies.get("login_token");
  if (!token) {
    return {
      status: "error",
      message: "توکنی یافت نشد!",
    };
  }
  removeFromStorage();
  // let decodedToken;
  // try {
  //     decodedToken = jwt.verify(token, "base64:m+0hF39JaioKfJYTbS4LNGbHCXNHWnHELNumPMBi+3Q=");
  // } catch (err) {
  //     return {
  //         status: 'error',
  //         message: "توکن نامعتبر است!",
  //     };
  // }

  // const data = await postFetchWithOutForm('/auth/logout', {'Authorization': `Bearer ${token}`});
  Cookies.remove("login_token");
  return {
    status: "success",
    message: "با موفقیت خارج شدید!",
  };
}

export { login, logout };
